import {
  Box,
  Grid,
  IconButton,
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Typography,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
} from "@mui/material";
import React, { useState, useEffect, useRef } from "react";
import Header from "./Header";

import { Link } from "react-router-dom";

import LogoutIcon from "@mui/icons-material/Logout";
import companyLogo from "../assets/images/Logo/lmgg-logo-01-300x75 (1).png";

import "../assets/css/style.css";
import Sidenav, { SideNav } from "../layout/Sidenav";
import PowerSettingsNewIcon from "@mui/icons-material/PowerSettingsNew";
import { handleLogout } from "../commonFunctions/logout";

// Every page wraps itself in its own <Layout> (no shared/persistent layout
// via a router <Outlet>), so navigating to a new page unmounts this whole
// component — including the sidebar's scrollable list — and mounts a brand
// new one. A fresh DOM node always starts at scrollTop 0, which is why
// scrolling the sidebar down and then clicking a link visually "jumps back
// up": it's not actually scrolling back, it's a new element that was never
// scrolled in the first place. Persisting the scroll position outside React
// (sessionStorage, not state) and restoring it on the next mount fixes the
// visible symptom without the much larger job of restructuring routing so
// Layout/Sidenav stop remounting per page.
const SIDENAV_SCROLL_KEY = "lmggt_sidenav_scroll_top";

function Layout(props) {
  const sidebarPersistent = useRef({
    opened: true,
    hover: false,
  });
  const sidenavRef = useRef(null);

  useEffect(() => {
    const el = sidenavRef.current;
    if (!el) return;
    const saved = sessionStorage.getItem(SIDENAV_SCROLL_KEY);
    if (saved) el.scrollTop = parseInt(saved, 10) || 0;

    const handleScroll = () => {
      sessionStorage.setItem(SIDENAV_SCROLL_KEY, String(el.scrollTop));
    };
    el.addEventListener("scroll", handleScroll, { passive: true });
    return () => el.removeEventListener("scroll", handleScroll);
  }, []);

  const companyLogo =
    "https://pfb3tybxnslu7y2e.public.blob.vercel-storage.com/uploads/LMGG%20%281%29-TqX3f1IBK8HeRMUjihBXaklxEG3AsJ.png";
  const shortLogo =
    "https://pfb3tybxnslu7y2e.public.blob.vercel-storage.com/uploads/LMGG%20short%20logo-Pi3cYubMspbCiLeOi4TeIx5KHpt0RH.png";

  const [logoutDialogOpen, setLogoutDialogOpen] = useState(false);

  const handleLogoutClick = () => {
    setLogoutDialogOpen(true);
  };

  const handleLogoutCancel = () => {
    setLogoutDialogOpen(false);
  };

  const handleLogoutConfirm = () => {
    setLogoutDialogOpen(false);
    handleLogout();
  };

  const [menuOpenedFlag, setMenuOpenedFlag] = useState(
    sidebarPersistent.current.opened
  );
  const [menuHover, setMenuHover] = useState(sidebarPersistent.current.hover);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 768);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const setMenuState = (opened, hover) => {
    sidebarPersistent.current = { opened, hover };
    setMenuOpenedFlag(opened);
    setMenuHover(hover);
  };

  const showMenuIcon = () => {
    setMenuOpenedFlag(!menuOpenedFlag);
  };

  return (
    <Box>
      <Grid container>
        {/* Sidebar */}
        <Grid
          ref={sidenavRef}
          className={`sidenav ${
            menuOpenedFlag || menuHover ? "open" : "closed"
          }`}
          onMouseEnter={() => {
            if (!menuOpenedFlag && !isMobile) setMenuState(false, true);
          }}
          onMouseLeave={() => {
            if (!menuOpenedFlag && !isMobile) setMenuState(false, false);
          }}
        >
          <Grid textAlign={`right`}></Grid>
          <List>
            <ListItem disablePadding sx={{ display: "block" }}>
              <Box className="sidenav-logo">
                <img
                  src={menuOpenedFlag || menuHover ? companyLogo : shortLogo}
                  alt="LMGGT"
                  width={menuOpenedFlag || menuHover ? `200px` : `75px`}
                  height={`auto`}
                  style={{ transitions: "width 0.3s ease" }}
                  className="sidenav-logo-img"
                />
              </Box>

              <Grid className="left-menu">
                <Sidenav
                  menuOpenedFlag={menuOpenedFlag}
                  setMenuState={setMenuState}
                />
              </Grid>

              <Link onClick={handleLogoutClick} className={`logout-btn`}>
                <ListItemButton
                  sx={{
                    minHeight: 48,
                    px: menuOpenedFlag || menuHover ? 2.5 : 0,
                    display: "flex",
                    gap: menuOpenedFlag || menuHover ? 0.8 : 0,
                    justifyContent: menuOpenedFlag || menuHover ? "flex-start" : "center",
                    color: "#dc2626",
                    fontWeight: 600,
                    "& svg": {
                      color: "#dc2626",
                      fontSize: "22px",
                    },
                  }}
                >
                  <ListItemIcon
                    sx={{
                      minWidth: 0,
                      justifyContent: "center",
                    }}
                  >
                    <PowerSettingsNewIcon />
                  </ListItemIcon>

                  <ListItemText
                    primary="Logout"
                    sx={{
                      "& .MuiListItemText-primary": {
                        fontWeight: 600, // text slightly bold
                      },
                    }}
                  />
                </ListItemButton>
              </Link>
            </ListItem>
          </List>
        </Grid>

        {/* Overlay for mobile */}
        {isMobile && menuOpenedFlag && (
          <div
            className="overlay active"
            onClick={() => setMenuOpenedFlag(false)}
          ></div>
        )}

        {/* Main Content */}
        <Grid
          className="topnav"
          style={{
            marginLeft: isMobile
              ? "0"
              : menuOpenedFlag || menuHover
              ? "280px"
              : "70px",
            width: isMobile
              ? "100vw"
              : menuOpenedFlag || menuHover
              ? "calc(100vw - 280px)"
              : "calc(100vw - 70px)",
            transition: "margin-left 0.25s ease, width 0.25s ease",
          }}
        >
          <Header
            menuAction={showMenuIcon}
            menuOpenedFlag={menuOpenedFlag}
            sidebarOpen={menuOpenedFlag || menuHover}
            isMobile={isMobile}
          />
          {props.children}
        </Grid>

        {/* Logout Confirmation Dialog */}
        <Dialog
          open={logoutDialogOpen}
          onClose={handleLogoutCancel}
          PaperProps={{
            sx: {
              borderRadius: "16px",
              padding: "8px",
              minWidth: "400px",
            },
          }}
        >
          <DialogTitle sx={{ pb: 2, fontSize: "1.25rem", fontWeight: 600 }}>
            Confirm Logout
          </DialogTitle>
          <DialogContent>
            <Typography variant="body1" sx={{ color: "#64748b" }}>
              Are you sure you want to logout?
            </Typography>
          </DialogContent>
          <DialogActions sx={{ px: 3, pb: 2.5, gap: 1 }}>
            <Button
              onClick={handleLogoutCancel}
              variant="outlined"
              sx={{
                textTransform: "none",
                borderRadius: "8px",
                px: 3,
                py: 1,
                borderColor: "#e2e8f0",
                color: "#64748b",
                "&:hover": {
                  borderColor: "#cbd5e1",
                  backgroundColor: "#f8fafc",
                },
              }}
            >
              Cancel
            </Button>
            <Button
              onClick={handleLogoutConfirm}
              variant="contained"
              sx={{
                textTransform: "none",
                borderRadius: "8px",
                px: 3,
                py: 1,
                backgroundColor: "#ef4444",
                "&:hover": {
                  backgroundColor: "#dc2626",
                },
              }}
            >
              Logout
            </Button>
          </DialogActions>
        </Dialog>
      </Grid>
    </Box>
  );
}

export default Layout;
